import Modal from '../common/Modal';
import UpiScanner from './UpiScanner';

/** Scanner opened from the transaction form's UPI field. */
export default function UpiScannerModal({ isOpen, onClose, onResult }) {
  if (!isOpen) return null;
  return (
    <Modal isOpen onClose={onClose} title="Scan UPI QR" size="sm">
      <UpiScanner onResult={onResult} showRecents={false} />
    </Modal>
  );
}
